
$(document).ready(function () {
  
  $(window).load(function(){   	
      $(".site-header").sticky({ topSpacing: 0, center:true });
  });
  
  $(window).load(function(){ 
  		var elements = $('.sticky');
  		Stickyfill.add(elements);
  });
  
  $('.hero__title').prepend(function (index) {
      index = '00' + (index + 1);
      return '<span class=index>' + index.substr(index.length - 2) + '</span>';
  });
  
  $(".site-nav__item.site-nav--has-dropdown").hover(function() {
      $(this).find(".col").addClass("show");
      $('.nav-shade').addClass("display"); 
  }, function() { 
      $(this).find(".col").removeClass("show");
      $('.nav-shade').removeClass("display");
  });  
  
  $(".guide-link-1").click(function (){
      $('html, body').animate({scrollTop: $('#buying-guide').offset().top }, 'slow');
  });   
  $(".guide-link-2").click(function (){
      $('html, body').animate({scrollTop: $('#thickness').offset().top }, 'slow');
  });  
  $(".guide-link-3").click(function (){
      $('html, body').animate({scrollTop: $('#leather-hide-parts').offset().top }, 'slow');
  });
  $(".guide-link-4").click(function (){
      $('html, body').animate({scrollTop: $('#hardware-measuring').offset().top }, 'slow');
  });   
  $(".guide-link-5").click(function (){
      $('html, body').animate({scrollTop: $('#terminology').offset().top }, 'slow');
  });  
  
  $("#shopify-section-guide-list div").click(function () {
      $(this).addClass("active");
      $("#shopify-section-guide-list div").not(this).removeClass("active");
  });
  
  $("#shopify-section-guide-list span").click(function (){
  	  if($("#shopify-section-guide-list").hasClass("open")){
        $("#shopify-section-guide-list").removeClass("open");
        $("#shopify-section-guide-list").stop().animate({
          height: '40px'
        }, 300);
      }else{
        $("#shopify-section-guide-list").stop().animate({
          height: '160px'
        }, 300);
        $("#shopify-section-guide-list").addClass("open");
      }	
  });
  
  $(function() {
    if (location.hash === "#buying-guide") {
        $(".guide-link-1").addClass("active");
    }
    else if (location.hash === "#thickness") {
        $(".guide-link-2").addClass("active");
    }    
    else if (location.hash === "#leather-hide-parts") {
        $(".guide-link-3").addClass("active");
    }
    else if (location.hash === "#hardware-measuring") {
        $(".guide-link-4").addClass("active");
    }
    else if (location.hash === "#terminology") {
        $(".guide-link-5").addClass("active");
    }    
  });
  

});  

var docWidth = document.documentElement.offsetWidth;

[].forEach.call(
  document.querySelectorAll('*'),
  function(el) {
    if (el.offsetWidth > docWidth) {
      console.log(el);
    }
  }
);